import React, { Component } from "react";
import httprequester from "../../../lib/requester";
import BarcodeReader from "react-barcode-reader";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import ReactTable from "react-table";
import "react-table/react-table.css";
import _ from "lodash";

class Scan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: [],
      success: "",
      dataTable: [],
      scannedNumber: 0,
      barcode_scan: "",
      snapId: moment(new Date()).format('YYYYMMDD'),
      isOpen: false,
      disabledButton: false,
      loading: false,
      btnText: 'Activate',
      user: JSON.parse(window.localStorage.getItem('is_user')),
      opendebitur: {},
    };
  }

  componentDidMount = () => {
    this.getOpen()
  };

  getCurrentSnapId = () => {
    let { user, snapId } = this.state
    let param = {
      org_id: user.org_id,
      snap_id: snapId
    }

    let url = '/api/collect/v1/opname-debitur/get-current-snapid'
    httprequester.postCollect(url, param, {
      success: function(response) {
        let { data } = response.data
        if (data.header_id) {
          // Open OR Close
          this.setState({
            disabledButton: data && data.status === 'O' ? false : true, 
            isOpen: data && data.status === 'O' ? true : false,
            btnText: data && data.status === 'O' ? 'Close' : 'Activate'
          })
        } else {
          // No Record
          this.setState({
            disabledButton: false, 
            isOpen: false,
            btnText: 'Activate'
          })
        }
      }.bind(this),
      error: function(e) {
        console.log(e.message)
      }.bind(this)
    })
  }

  getOpen = () => {
    let { user } = this.state
    let url = '/api/collect/v1/opname-debitur/get-open-odeb?org_id=' + user.org_id
    httprequester.getCollect(url, {
      success: function(response) {
        let {data} = response.data
        if (data.header_id) {
          this.setState({ 
            opendebitur: data, 
            snapId: data.snap_id, 
            disabledButton: data && data.status === 'O' ? false : true, 
            isOpen: data && data.status === 'O' ? true : false,
            btnText: data && data.status === 'O' ? 'Close' : 'Activate'
          })
        } else {
          // Belum aktif / sudah close
          this.getCurrentSnapId()
        }
        this.getList()
      }.bind(this),
      error: function(e) {
        this.setState({ error: [e.message]})
      }.bind(this)
    })
  }

  findCurrentSnapId = () => {
    let { snapId } = this.state
    let find = _.find(this.state.dataTable, function(o) {
      return o.snap_id === parseInt(snapId)
    })

    this.setState({ 
      disabledButton: find ? true : false, 
      isOpen: false,
      btnText: find ? 'Close' : 'Activate' 
    })
  }

  getList = () => {
    let { user } = this.state
    let url = '/api/collect/v1/opname-debitur/list-header?org_id=' + user.org_id
    httprequester.getCollect(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({
          dataTable: data,
          scannedNumber: data.length
        })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return (
                <li key={index}>
                  <i class="fas fa-exclamation-triangle" /> {item}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  };

  handleChangeInput = (e) => {
    let name = e.currentTarget.name;
    let value = e.currentTarget.value;

    this.setState({ [name]: value });
  };

  handleActivate = () => {
    if (window.confirm('Activation will take longer time, please wait until the process is completed.')) {
      let { user, snapId } = this.state
      let url = '/api/collect/v1/opname-debitur/insert-header'
      let param = {
        org_id: user.org_id,
        snap_id: snapId,
        branch_code: user.org_name,
        user_id: user.user_id,
        username: user.username
      }
      this.setState({ loading: true })
      httprequester.postCollect(url, param, {
        success: function(response) {
          let { message, data } = response.data
          this.setState({ success: message, loading: false })
          this.getOpen()
  
          let app = this
          window.setTimeout(() => {
            app.setState({ success: '' })
          }, 2000)
        }.bind(this),
        error: function(e) {
          this.setState({ error: [e.response.data.message || 'Failed to request API'], loading: false })
        }.bind(this)
      })
    }
  }

  handleClose = () => {
    let { user, snapId } = this.state
    let url = '/api/collect/v1/opname-debitur/close'
    let param = {
      snapId: snapId,
      orgId: user.org_id
    }
    httprequester.postCollect(url, param, {
      success: function(response) {
        this.setState({
          success: response.data.message || 'Successfully Closed'
        })
        window.setTimeout(() => {
          window.location.reload()
        }, 1000)
      }.bind(this),
      error: function(e) {
        this.setState({
          error: [e.response.data.message || 'Failed request to API']
        })
      }.bind(this)
    })
  }

  renderFilter = () => {
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-8">
                  <h3>Snap ID: { this.state.snapId }</h3>
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    disabled={this.state.disabledButton}
                    onClick={this.handleSubmit.bind(this)}
                  >
                    { this.state.btnText }
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  handleError = (e) => {
    console.log(e);
  };

  handleScan = (data) => {
    this.setState({ barcode_scan: data });
  };

  renderInputBarcode = () => {
    return (
      <div>
        <BarcodeReader
          onError={this.handleError.bind(this)}
          onScan={this.handleScan.bind(this)}
        />
      </div>
    );
  };

  renderTable = () => {
    let app = this
    const data = {
      columns: [
        {
          Header: "No",
          accessor: "header_id",
          width: 50,
          Cell: function(row) {
            return (
              <span>{ row.index + 1 }</span>
            )
          }
        },
        {
          Header: 'Opname Date',
          accessor: "opname_date",
          filterable: true,
          Cell: function(row) {
            let date = row.value ? moment(row.value).format('DD-MMM-YYYY') : ''
            return (
              <span>{date}</span>
            )
          }
        },
        {
          Header: 'Report',
          accessor: 'header_id',
          filterable: true,
          Cell: function(row) {
            return (
              <div className="row">
                <div className="col-md-6"><button className="btn btn-success btn-block" onClick={() => { app.handleReport(row, 'EXCEL')}}><i className="fa fa-file-excel"></i> Excel</button></div>
                <div className="col-md-6"><button className="btn btn-danger btn-block" onClick={() => {app.handleReport(row, 'PDF')}}><i className="fa fa-file-pdf"></i> PDF</button></div>
              </div>
            )
          }
        }
      ],
      rows: this.state.dataTable,
    };

    return (
      <div className="row">
        <div className="col-md-8">
          <ReactTable
            className="fullWidth"
            data={data.rows}
            columns={data.columns}
            defaultPageSize={10}
            defaultFilterMethod={(filter, row, column) => {
              let columnes = row[filter.id];
              return columnes
                ? columnes.toLowerCase().includes(filter.value.toLowerCase())
                : "";
            }}
          />
        </div>
      </div>
    );
  };

  handleReport = (row, type) => {
    let { user } = this.state
    let url = "/api/collect/v1/opname-report/generate-report"
    let param = {
      "header_id": row.original.header_id,
      "snap_id": row.original.snap_id,
      "org_id": user.org_id,
      "document": type
    }

    this.setState({ loading: true })
    httprequester.postCollect(url, param, {
      success: function(response) {
        let { data } = response.data
        let path = (data && data.length > 0) ? data[0].path : ""
        if (path.length > 0) {
          window.open(path, '_blank')
        }
        this.setState({ loading: false })
      }.bind(this),
      error: function(e) {
        console.log(e.message)
        this.setState({ loading: false })
      }.bind(this)
    })
  }

  handleSubmit = () => {
    if (this.state.isOpen) {
      this.handleClose()
    } else {
      this.handleActivate()
    }
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showNotification()}
                    {this.renderFilter()}
                    {this.renderTable()}
                    {this.renderInputBarcode()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default Scan;
